import React, { useContext, useMemo } from 'react';
import Box from '@material-ui/core/Box';
import { AppBar, createTheme, usePhoneView } from '@michelin/acid-components';
import { ThemeProvider } from '@material-ui/styles';
import { LocationSelector } from '../LocationSelector/LocationSelector';
import { LogoHeader } from '../Logo/LogoHeader';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import { NotificationButton } from '../../compositions/Notifications/NotificationButton';
import { GlobalSearch } from '../GlobalSearch/GlobalSearch';
import { useStyles } from '../../styles/headerStyles';
import { AppsMenu } from '../AppsMenu/AppsMenu';
import { ProfileBox } from '../ProfileBox/ProfileBox';
import { useGetAccessToken } from '../../hooks/useGetAccessToken';
export var CentralProviderHeader = function (_a) {
    var customLink = _a.customLink, _b = _a.logoType, logoType = _b === void 0 ? 'poweredByMichelin' : _b, _c = _a.profileMenuItems, profileMenuItems = _c === void 0 ? [] : _c, onNavigate = _a.onNavigate;
    var phoneView = usePhoneView('sm');
    var classes = useStyles({});
    var _d = useContext(CentralProviderContext), sidebarRef = _d.sidebarRef, centralProfile = _d.centralProfile, currentTheme = _d.currentTheme, disableNotifications = _d.disableNotifications, allowedLanguages = _d.allowedLanguages;
    var accessToken = useGetAccessToken();
    var auth = !!accessToken;
    var getName = function () {
        var name;
        var profile = centralProfile.profile;
        if (profile.profile_type === 'business') {
            name = profile.company_name;
        }
        else if (profile.first_name || profile.last_name) {
            name = "".concat(profile.first_name || '', " ").concat(profile.last_name || '');
        }
        return name || centralProfile.auth0.name || centralProfile.auth0.nickname;
    };
    return useMemo(function () { return (React.createElement(React.Fragment, null, auth && centralProfile ? (React.createElement(ThemeProvider, { theme: createTheme({ palette: { type: currentTheme } }) },
        React.createElement(Box, { className: classes.appBar },
            React.createElement(AppBar, { fixed: true },
                React.createElement(LogoHeader, { onNavigate: onNavigate, logoType: logoType }),
                !phoneView && !sidebarRef && (React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '14px 0',
                        width: '320px',
                        height: '65px',
                    } },
                    React.createElement(AppsMenu, { small: false }))),
                React.createElement("div", { className: classes.growContainer }),
                React.createElement("div", { className: classes.grow }),
                React.createElement("div", { className: classes.sectionContent },
                    React.createElement(GlobalSearch, null),
                    !disableNotifications && React.createElement(NotificationButton, null),
                    React.createElement("div", { className: classes.flexContainer }, customLink || null),
                    React.createElement("div", { className: classes.locationSelector },
                        React.createElement(LocationSelector, null)),
                    React.createElement(ProfileBox, { showAppMenu: !sidebarRef && phoneView, name: getName(), email: centralProfile.email, userRole: centralProfile.userRole || centralProfile.auth0.userRole, profileMenuItems: profileMenuItems, languages: allowedLanguages, onNavigate: onNavigate })))),
        React.createElement("div", { style: { height: '4rem' } }))) : null)); }, [
        auth,
        sidebarRef,
        centralProfile,
        currentTheme,
        disableNotifications,
        allowedLanguages,
        onNavigate,
        profileMenuItems,
    ]);
};
//# sourceMappingURL=CentralProviderHeader.js.map